import { render, staticRenderFns } from "./schemeRentInfo.vue?vue&type=template&id=52fad08a"
import script from "./schemeRentInfo.vue?vue&type=script&lang=js"
export * from "./schemeRentInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports